import Create from 'src/pages/Products/Variations/Create.vue'
import FastCreate from 'src/pages/Products/Variations/FastCreate.vue'

const auth = { requiresAuth: true }
const saveFrom = { saveFrom: true }
const notUser = { requiresNotUser: true }

export default [
  {
    path: '/products/:id/variations/create',
    name: 'Variation Erstellen',
    component: Create,
    meta: { ...auth, ...notUser, ...saveFrom }
  },
  {
    path: '/products/:id/variations/fast_create',
    name: 'Variationen Schnellanlage',
    component: FastCreate,
    meta: { ...auth, ...notUser, ...saveFrom }
  }
]
